<h1 mat-dialog-title>Rectifique el sentimiento asignado al siguiente texto</h1>
<div mat-dialog-content>
    <table>
        <tr>
            <td colspan="2" style="padding: 10px 0 10px 0;">{{data.text}}</td>
        </tr>
        <tr>
            <td style="width:150px; padding: 10px 0;">Sentimiento asignado</td>
            <td>{{data.sentiment}}</td>
        </tr>
        <tr>
            <td style="width:150px; padding: 0 0 20px 0;">Sentimiento rectificado</td>
            <td>
                <select title="sentiment-selector" [(ngModel)]="selectedSentiment">
                    <option *ngFor="let sentiment of listOfSentiments">
                        {{sentiment.name}}
                    </option>
                </select>
            </td>
        </tr>
    </table>
</div>
<div mat-dialog-actions>
    <button class="active:bg-blueGray-600 text-sm rounded shadow hover:shadow-lg p-1" mat-button
        (click)="onCancelClick()" style="margin: 0 30px 0 0;">Cancelar</button>
    <button class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm rounded shadow hover:shadow-lg p-1"
        mat-button (click)="onRectifyClick()">Rectificar</button>
</div>
